var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "form" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save($event)
                }
              }
            },
            [
              _c("div", { staticClass: "vx-row mt-4" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-3/12 w-full mb-2" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Tipo Email",
                          "label-for": "email_type_id"
                        }
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "email_type_id" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "v-select",
                                    {
                                      attrs: {
                                        options: _vm.emailTypeList,
                                        label: "name"
                                      },
                                      model: {
                                        value: _vm.emailType,
                                        callback: function($$v) {
                                          _vm.emailType = $$v
                                        },
                                        expression: "emailType"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "no-options" },
                                          slot: "no-options"
                                        },
                                        [_vm._v("Nenhum registro encontrado!")]
                                      )
                                    ]
                                  ),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-7/12 w-full mb-2" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: { label: "Email", "label-for": "email_address" }
                      },
                      [
                        _c("validation-provider", {
                          attrs: { name: "email_address", rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    staticClass: "required",
                                    attrs: {
                                      type: "email",
                                      id: "email_address",
                                      state: errors.length > 0 ? false : null,
                                      name: "email_address"
                                    },
                                    model: {
                                      value: _vm.emailAddress,
                                      callback: function($$v) {
                                        _vm.emailAddress = $$v
                                      },
                                      expression: "emailAddress"
                                    }
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "vx-col sm:w-2/12 w-full mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "vx-col w-full" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "mt-6 float-right",
                          model: {
                            value: _vm.head,
                            callback: function($$v) {
                              _vm.head = $$v
                            },
                            expression: "head"
                          }
                        },
                        [_vm._v("Email principal")]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _vm.editMode
                      ? _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { "400": true }
                              }
                            ],
                            staticClass: "mt-5 float-right",
                            attrs: { variant: "danger" },
                            on: { click: _vm.cancelEdit }
                          },
                          [_vm._v(" Cancelar ")]
                        )
                      : _vm._e(),
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "ripple",
                            rawName: "v-ripple.400",
                            value: "rgba(255, 255, 255, 0.15)",
                            expression: "'rgba(255, 255, 255, 0.15)'",
                            modifiers: { "400": true }
                          }
                        ],
                        class: ["mt-5 float-right", { "mr-2": _vm.editMode }],
                        attrs: {
                          variant: "primary",
                          type: "submit",
                          disabled: !_vm.validateForm
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(this.editMode ? "Alterar" : "Adicionar") +
                            " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "vx-row mt-4 mb-10" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full" },
          [
            _c(
              "vs-table",
              {
                attrs: {
                  data: _vm.emailList,
                  "no-data-text": "Nenhum registro encontrado"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var data = ref.data
                      return _vm._l(data, function(tr, indextr) {
                        return _c(
                          "vs-tr",
                          { key: indextr },
                          [
                            _c("vs-td", [
                              _vm._v(_vm._s(data[indextr].email_type.name))
                            ]),
                            _c("vs-td", [
                              _vm._v(_vm._s(data[indextr].email_address))
                            ]),
                            _c("vs-td", [
                              data[indextr].pivot.head
                                ? _c("span", [_vm._v("Sim")])
                                : _c("span", [_vm._v("Não")])
                            ]),
                            _c(
                              "vs-td",
                              [
                                _c("feather-icon", {
                                  staticClass:
                                    "h-5 w-5 mb-1 mr-3 stroke-current text-warning",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { icon: "EditIcon", title: "Editar" },
                                  on: {
                                    click: function($event) {
                                      return _vm.edit(data[indextr])
                                    }
                                  }
                                }),
                                _c("feather-icon", {
                                  staticClass:
                                    "h-5 w-5 mb-1 mr-3 stroke-current text-danger",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { icon: "Trash2Icon" },
                                  on: {
                                    click: function($event) {
                                      return _vm.destroy(data[indextr])
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    }
                  }
                ])
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Tipo")]),
                    _c("vs-th", [_vm._v("Email")]),
                    _c("vs-th", [_vm._v("Principal")]),
                    _c("vs-th", [_vm._v("Ação")])
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }